<template>
  <div class="payment-error">
    <div class="payment-error__content">
      <div class="error">
        <AmIconMaterial
          class="error__icon text--red"
          name="warning"
          size="md"
        />
        <AmTypography
          :text="$t('steps.payment.paymentProcessError.title')"
          text-color="error"
          typography-style="l6"
          weight="bold"
        />
      </div>
      <PurchaseSummary
        v-if="['card', 'applepay'].includes(paymentType)"
        :installmentSeletedLabel="installmentSeletedLabel"
        :paymentType="paymentType"
      />
    </div>
    <div class="payment-error__actions">
      <AmButton
        :class="[disabledTryAgain(), 'tryagain']"
        :label="tryAgainButtonText"
        size="xl"
        full-width
        :icon="tryAgainButtonIcon"
        :disabled="enabledTryAgainPayment"
        @click="returnPaymentCardDataPayment()"
      >
        <template
          v-if="loadingGlobal"
          #content
        >
          <AmLoading
            class="loading--white"
            :AmLoaderSize="35"
          />
        </template>
      </AmButton>

      <AmTypography
        :class="['return', `text--${theme.color}`]"
        typography-style="l5"
      >
        <template #default>
          <div @click="returnPaymentCardDataPayment()">
            {{ $t('return') }}
          </div>
        </template>
      </AmTypography>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapState, mapMutations, mapActions } from 'vuex'
import PurchaseSummary from '@/views/Checkout/partials/PurchaseSummary/PurchaseSummary.vue'
import queryPersistance from '@/components/mixins/queryPersistance'

export default {
  name: 'PaymentError',
  components: {
    PurchaseSummary,
  },
  mixins: [themeMixin, currencyFilterMixin, queryPersistance],
  data() {
    return {
      enabledTryAgainPayment: true,
      paymentTypesChangePaymentButton: ['billet', 'pix'],
    }
  },
  computed: {
    ...mapState('Checkout', {
      loadingGlobal: (state) => state.globalLoading,
      paymentType: (state) => state.payment_type,
      cartStatus: (state) => state.cart,
      paymentCard: (state) => state.paymentCard,
      cartHash: (state) => state.cartHash,
    }),
    currentPaymentTypeSelected() {
      return this.paymentType
    },
    isPaymentBilletOrPix() {
      return this.paymentTypesChangePaymentButton.includes(this.currentPaymentTypeSelected)
    },
    installmentSeletedLabel() {
      if (this.paymentType === 'card') {
        return this.paymentCard.installments.label
      }
      return ''
    },
    tryAgainButtonText() {
      const paymentTexts = {
        card: this.$t('steps.payment.tryAgainPayment.card'),
        billet: this.$t('steps.payment.tryAgainPayment.billet'),
        pix: this.$t('steps.payment.tryAgainPayment.pix'),
        applepay: this.$t('steps.payment.tryAgainPayment.card'),
      }

      return paymentTexts[this.currentPaymentTypeSelected]
    },
    tryAgainButtonIcon() {
      const paymentTexts = {
        card: 'shopping_bag',
        billet: 'rotate_right',
        pix: 'pix',
        applepay: 'shopping_bag',
      }

      return {
        name: paymentTexts[this.currentPaymentTypeSelected],
        position: 'left',
        type: 'material',
        size: 'xl',
      }
    },
  },
  watch: {
    loadingGlobal: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.enabledTryAgainPayment = true
          return newValue
        }

        this.enabledTryAgainPayment = false
        return newValue
      },
    },
  },
  mounted() {
    this.SET_CURRENT_STEP(-1)
    if (!this.$route.params.history) {
      this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
    }
  },
  destroyed() {
    this.reloadCart()
  },
  methods: {
    ...mapActions('Card', ['resetCard']),
    ...mapMutations('Checkout', ['SET_CURRENT_STEP']),
    ...mapActions('Cart', ['fetchCart']),
    disabledTryAgain() {
      return this.enabledTryAgainPayment ? '' : this.theme.color
    },
    returnPaymentCardDataPayment() {
      this.resetCard()

      if (this.currentPaymentTypeSelected === 'card') {
        this.$router.push({
          name: 'new.stepPayment-card',
          params: { history: true },
          query: { pl: this.getPl?.pl },
        })
        return
      }

      if (this.currentPaymentTypeSelected === 'applepay') {
        this.$router.push({
          name: 'new.stepPayment',
          params: { history: true },
          query: { pl: this.getPl?.pl },
        })
        return
      }

      this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
    },
    async reloadCart() {
      if (this.$route.name === 'new.stepPayment') {
        try {
          const { cart } = this.cartHash
          await this.fetchCart(cart)
        } catch (error) {
          this.$AmAlert({
            type: 'error',
            description: this.$t('steps.cardFetchErr'),
            autoHide: true,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-error {
  justify-content: space-between;
  flex: 1;
  width: 100%;

  &,
  &__content {
    display: flex;
    flex-direction: column;
  }

  .tryagain {
    margin-top: 20px;
    margin-bottom: 12px;
  }

  .error {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 27px;

    &__icon {
      margin-right: 10px;
    }
  }

  .return {
    cursor: pointer;
    margin-top: 24px;
    text-align: center;
  }
}
</style>
